// src/components/patterns/PatternCard.js - Pattern card component
const PatternCard = ({ pattern, onClick }) => {
  const formatPatternType = (type) => {
    return type
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const getPatternIcon = (type) => {
    const icons = {
      'similar_content': '📝',
      'geographic_cluster': '🌍',
      'repeated_source': '🔗',
      'temporal_spike': '📈'
    };
    return icons[type] || '🔍';
  };

  const getSeverityColor = (severity) => {
    const colors = {
      'critical': 'bg-red-100 dark:bg-red-900/20 text-red-800 dark:text-red-400 border-red-200 dark:border-red-800',
      'high': 'bg-red-100 dark:bg-red-900/20 text-red-800 dark:text-red-400 border-red-200 dark:border-red-800',
      'medium': 'bg-yellow-100 dark:bg-yellow-900/20 text-yellow-800 dark:text-yellow-400 border-yellow-200 dark:border-yellow-800',
      'low': 'bg-gray-100 dark:bg-gray-900/20 text-gray-800 dark:text-gray-400 border-gray-200 dark:border-gray-800'
    };
    return colors[severity] || colors.low;
  };

  const patternData = typeof pattern.pattern_data === 'string' 
    ? JSON.parse(pattern.pattern_data) 
    : pattern.pattern_data;

  return (
    <div
      onClick={onClick}
      className={`p-4 bg-white dark:bg-shayek-dark-100 rounded-lg shadow border-2 cursor-pointer hover:shadow-md transition-all border-shayek-light-300 dark:border-shayek-dark-200 ${
        pattern.severity === 'high' || pattern.severity === 'critical'
          ? 'border-red-200 dark:border-red-800'
          : pattern.severity === 'medium'
          ? 'border-yellow-200 dark:border-yellow-800'
          : 'border-gray-200 dark:border-gray-800'
      }`}
    >
      <div className="flex justify-between items-start mb-2">
        <div className="flex items-center gap-2">
          <span className="text-2xl">{getPatternIcon(pattern.pattern_type)}</span>
          <div>
            <h3 className="text-sm font-semibold text-gray-900 dark:text-shayek-dark-900">
              {formatPatternType(pattern.pattern_type)}
            </h3>
            <p className="text-xs text-gray-500 dark:text-shayek-dark-500">
              {new Date(pattern.detected_at).toLocaleString()}
            </p>
          </div>
        </div>
        <span className={`px-2 py-1 text-xs font-medium rounded border ${getSeverityColor(pattern.severity)}`}>
          {pattern.severity}
        </span>
      </div>

      <div className="mt-3 space-y-1">
        {pattern.pattern_type === 'similar_content' && (
          <p className="text-sm text-gray-600 dark:text-shayek-dark-600">
            {patternData.cluster_size} similar reports detected
            {patternData.category && ` in category: ${patternData.category}`}
          </p>
        )}
        {pattern.pattern_type === 'geographic_cluster' && (
          <p className="text-sm text-gray-600 dark:text-shayek-dark-600">
            {patternData.count} reports from {patternData.country}
            {patternData.region && `, ${patternData.region}`}
            {patternData.category && ` in category: ${patternData.category}`}
          </p>
        )}
        {pattern.pattern_type === 'repeated_source' && (
          <p className="text-sm text-gray-600 dark:text-shayek-dark-600">
            {patternData.report_count} reports from same source
            <br />
            <span className="text-xs text-gray-500 dark:text-shayek-dark-500 truncate block max-w-md">
              {patternData.source_url}
            </span>
          </p>
        )}
        {pattern.pattern_type === 'temporal_spike' && (
          <p className="text-sm text-gray-600 dark:text-shayek-dark-600">
            {patternData.count} reports on {new Date(patternData.date).toLocaleDateString()}
            {patternData.category && ` in category: ${patternData.category}`}
            {patternData.average && (
              <span className="text-xs text-gray-500 dark:text-shayek-dark-500">
                {' '}(avg: {patternData.average.toFixed(1)})
              </span>
            )}
          </p>
        )}
      </div>

      {pattern.affected_report_ids && pattern.affected_report_ids.length > 0 && (
        <div className="mt-3 pt-3 border-t border-gray-200 dark:border-shayek-dark-200">
          <p className="text-xs text-gray-500 dark:text-shayek-dark-500">
            {pattern.affected_report_ids.length} affected report{pattern.affected_report_ids.length !== 1 ? 's' : ''}
          </p>
        </div>
      )}
    </div>
  );
};

export default PatternCard;

